import { useAuth } from '@backoffice-frontend/authentication'
import { useErrorHandlingMutation } from '@backoffice-frontend/data-fetching'
import { useMoiaSuccessNotification } from '@backoffice-frontend/patterns'
import { Button } from '@moia-dev/pace-web'
import { jwtDecode } from 'jwt-decode'
import { useTranslation } from 'react-i18next'
import { useProlongSessionMutation } from './SessionProlongButton.hook'

type TemporaryBackofficeSessionToken = {
  temporarySessionId?: string
}

export const SessionProlongButton = () => {
  const { t } = useTranslation()
  const { token } = useAuth()
  const { enqueueMoiaSuccessNotification } = useMoiaSuccessNotification()
  const [prolongSession, { loading }] = useErrorHandlingMutation(
    useProlongSessionMutation,
  )

  const temporarySessionId = token
    ? jwtDecode<TemporaryBackofficeSessionToken>(token).temporarySessionId
    : undefined

  if (!temporarySessionId) {
    return null
  }

  const handleProlong = async () => {
    const result = await prolongSession({
      variables: { input: { sessionId: temporarySessionId } },
    })

    if (result.data?.prolongTemporaryBackofficeSession) {
      enqueueMoiaSuccessNotification(t('tbs_prolongSession_notification'), {
        duration: 4000,
      })
    }
  }

  return (
    <Button
      size="compact"
      variant="secondary"
      label={t('tbs_prolongSession_button')}
      disabled={loading}
      onClick={handleProlong}
    />
  )
}
